<template>
  <div id="app">
     <router-view />
  </div>
</template>

<script src="https://unpkg.com/vue/dist/vue.js"></script>
<script src="https://unpkg.com/vue-i18n/dist/vue-i18n.js"></script>

<script>
// @ is an alias to /src


export default {
  name: 'App',
  components: {
  },
  data(){
    return {
     

    }
  },
  created(){
    // 判断屏幕宽度，动态设置视口，如果是大屏幕就不设置
    // if(window.screen.width < 360) {
    //  document.getElementsByTagName("head").append('<meta name="viewport" content="width=1280">')
    // } else if(window.screen.width < 1366) {
    //   document.getElementsByTagName("head").remove('[name="viewport"]')
    //   document.getElementsByTagName("head").append('<meta name="viewport" content="width=1366">')
    // }S
    // }
  },
  methods:{
  
  }
  }
</script>

<style lang="scss">

*{
	-webkit-box-sizing: border-box;
	-moz-box-sizing: border-box;
	box-sizing: border-box
}

*,body{
  padding:0px;	
  margin:0px;
  color: #222;
  font-family: "微软雅黑";
  // min-height: 100vh;
  // overflow-x: hidden;
  
}
body{ 
  // display: flex;
  // flex-direction:column ;
  max-width: 100vw;
  min-height: 100vh;
  // height: 100vh;
  background:#fff;
  overflow-x: hidden;
  padding: 0;
  margin: 0;
  // font-size: 100px;
   /* ios系统字体被手动调大优化 */
   -webkit-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;
  -moz-text-size-adjust: 100% !important;  
  
    
}
li{ 
  list-style-type:none;
}
i{ 
  margin:0px; 
  padding:0px; 
  text-indent:0px;
}
img{
   border:none; 
   max-width: 100%;
  }
  p{
    margin: 0;
    padding: 0;
  }
a{ 
  text-decoration:none; 
  color:#399bff;}
a.active,a:focus{ 
  outline:none!important; 
  text-decoration:none;}
ol,ul,p,h1,h2,h3,h4,h5,h6{ 
  padding:0; 
  margin:0}
a:hover{
   color:$hover-blue; 
   text-decoration: none!important}
i,em{
  font-style: normal;
  }
  .container{
    width: 18rem;
    margin-left: auto;
    margin-right: auto;
    //text-align: center;
  }
  .banner{
    position: relative;
    width: 100%;
    height:6.25rem;
    .carousel{
      width: 100%;
      height:6.25rem;
      img{
        width: 100%;
        height: 100%;
      }
    }
  }
  .ant-pagination-item{
        border-radius: 50%!important;
        overflow: hidden;
    }
    .ant-pagination-item-active{
      background: #0B6CC7!important;
      
    }
    .ant-pagination-item-active a{
      color: #fff!important;
    }
    // .ant-pagination-item:hover{
    //   background: #0B6CC7!important;
    //   border-radius: 50%!important;
    // }
    .ant-pagination-item:hover a{
      background: $hover-blue!important;
      color: #fff!important;
    }
  .ant-menu-submenu-title{
    padding: 0 .5rem!important;
    padding-bottom:.25rem !important ;
    }
  .ant-menu-vertical.ant-menu-sub,
    .ant-menu-vertical-left.ant-menu-sub, 
    .ant-menu-vertical-right.ant-menu-sub{
        font-size: $font-size16;
        min-width: 1.5rem!important;
    }
    .ant-menu-vertical {
        .ant-menu-item:not(.ant-menu-horizontal){
            margin-top: 0!important;
        }
    }
    .ant-menu:not(.ant-menu-horizontal) {
        .ant-menu-item-selected{
            background: #F1F1F1!important;
            color: #0B6CC7!important;
        }
    }
    .ant-menu:not(.ant-menu-horizontal) {
        .ant-menu-item-active{
            background: #F1F1F1!important;
            color: #0B6CC7!important;
            // border-bottom: .05rem solid #1890ff;
        }
    }
    .ant-menu > .ant-menu-item-divider{
      margin: 0!important;
      height: .0125rem!important;
    }
    .ant-menu-submenu-popup{
      top: 1.275rem!important;
      
    }
    .ant-btn > span{
        color: #fff!important;
    }
    .ant-menu-vertical > .ant-menu-item{
      height: .5rem!important;
      line-height: $font-size40!important;
    }
    .ant-input{
      font-size:$font-size16!important;
      // height: .4rem!important;
      height:.625rem!important;
      border: .0125rem solid #d9d9d9!important;
    }
    textarea.ant-input{
      min-height: 32px!important;
      height: 2.425rem!important;
    }
    .ant-form-item{
      margin-bottom: .3rem!important;
    }
    .ant-btn{
      height:.625rem!important;
      font-size: $font-size18!important;
      padding: 0 .1875rem!important;
    }
    .ant-pagination{
      font-size: $font-size14!important;
    }
    .ant-pagination-item{
      height: .4rem!important;
      min-width: .4rem!important;
      line-height: .375rem!important;
      margin-right: .1rem!important;
      border-width:.0125rem!important;
    }
    .ant-pagination-item a {
      padding: 0 .075rem!important;
    }
    .ant-pagination-prev,.ant-pagination-next{
      height: .4rem!important;
      min-width: .4rem!important;
      line-height:.4rem!important;
      border-radius: .05rem!important;
    }
    .ant-pagination-prev{
      margin-right: .1rem!important;
    }
    .ant-form-item-control{
      line-height: 0!important;
    }
    .ant-carousel .slick-dots li {
      margin: 0 .025rem!important;
    }
    .ant-carousel .slick-dots li.slick-active button {
      width: .3rem!important;
    }
    .ant-carousel .slick-dots li button {
      width: .2rem!important;
      height: .0375rem!important;
    }
    .ant-menu-vertical .ant-menu-item{
      height: .5rem!important;
      line-height: $font-size40!important;
    }
    .ant-menu-item-group-title{
      padding: 0!important;
    }
    .ant-menu-horizontal > .ant-menu-item{
      // border-bottom: .025rem solid transparent !important;
    }
    .ql-indent-1 {
        padding-left: 0px !important;
        text-indent: 1em !important;
    }

    .ql-indent-2 {
        padding-left: 0px !important;
        text-indent: 2em !important;
    }

    .ql-indent-3 {
        padding-left: 0px !important;
        text-indent: 3em !important;
    }

    .ql-indent-4 {
        padding-left: 0px !important;
        text-indent: 4em !important;
    }

    .ql-indent-5 {
        padding-left: 0px !important;
        text-indent: 5em !important;
    }

    .ql-indent-6 {
        padding-left: 0px !important;
        text-indent: 6em !important;
    }

    .ql-indent-7 {
        padding-left: 0px !important;
        text-indent: 7em !important;
    }

    .ql-indent-8 {
        padding-left: 0px !important;
        text-indent: 8em !important;
    }


</style>

